// Module
var code = "<!-- ko with: _component --> <div data-bind=\"blockElement: $data._loadInProgres\"> <!-- ko template: {html: GetTemplate} --><!-- /ko --> </div> <!-- /ko -->";
// Exports
export default code;